import React, { useEffect, useRef, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";


import { useDispatch, useSelector } from "react-redux";
import { click } from '@testing-library/user-event/dist/click';
import { tr } from 'date-fns/locale';

export default function PlusMinusBox(props) {

    const { 
        values,
        numValue,
        setValues,
        placeHolder,
        minusOff,
        plusFunc,
        unit=0, // 0=그냥 카운트, 1=만원, 2=십만원, 3=백만원, 4=천만원
        maxLength=12
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const inputRef = useRef(null);
    const [click, setClick] = useState(false);
    const [inputVal, setInputVal] = useState(numValue);

    return (
        <div className='plus_minus_box'>
            {minusOff ?
                <div className='button_off'
                    onClick={() => {
                        setClick(false);
                    }}
                >
                    <img src="./images/icons/subtract_line_grey.svg" width='20' />
                </div>
                :
                <div className='button'
                    onClick={() => {
                        setClick(false);
                        if(unit === 0) setValues(numValue - 1);
                        if(unit === 1) setValues(numValue - 10000);
                        if(unit === 2) setValues(numValue - 100000);
                        if(unit === 3) setValues(numValue - 1000000);
                        if(unit === 4) setValues(numValue - 10000000);
                        if(unit === 5) setValues(numValue - 10);
                        if(unit === 6) setValues(numValue - 100);
                        if(unit === 7) setValues(numValue - 1000);
                    }}
                >
                    <img src="./images/icons/subtract_line.svg" width='20' />
                </div>
            }

            <div className='price_info'
                onClick={async () => {
                    setClick(true);
                    setTimeout(() => {
                        inputRef?.current?.focus();
                    }, 200);
                }}
            >   
                {click ? 
                    <input 
                        ref={inputRef}
                        type={'number'} 
                        className={'plusminusinput'} 
                        value={numValue}
                        onChange={(e) => {
                            // setInputVal(e?.target?.value);
                            setValues(Number(e?.target?.value));
                        }} 
                        onBlur={(e) => {
                            setClick(false);
                        }}
                        onKeyDown={(e) => {
                            if(e.key === "Enter") {
                                setClick(false);
                            }
                        }}
                        onInput={(e) => {
                            if(e.target.value.length > maxLength) {
                                console.log('e.target.maxLength =>> ', e.target.maxLength)
                                e.target.value = e.target.value.slice(0, e.target.maxLength);
                            }
                        }}
                        onFocus={() => {
                            
                        }}
                        onClick={() => {

                        }}
                        // maxlength={maxLength}
                        // style={{}}
                        // readOnly={withButton === '주소찾기' || withButton === '지역선택' ? true : readOnly} 
                        // autoComplete={autoComplete}
                        // autoComplete={'off'}
                        // disabled={disableds}
                        // onWheel={(e) => e.target.blur()}
                    />
                    :
                    <p>{values ? values : placeHolder}</p>    
                }
            </div>

            <div className='button'
                onClick={() => {
                    setClick(false);

                    if(unit === 0) {
                        let val = (numValue*1) + 1;
                        setValues(val)
                        if(plusFunc) plusFunc(val);
                    };
                    if(unit === 1) {
                        let val = (numValue*1) + 10000;
                        setValues(val)
                        if(plusFunc) plusFunc(val);
                    };
                    if(unit === 2) {
                        let val = (numValue*1) + 100000;
                        setValues(val);
                        if(plusFunc) plusFunc(val);
                    };
                    if(unit === 3) {
                        let val = (numValue*1) + 1000000;
                        setValues(val);
                        if(plusFunc) plusFunc(val);
                    }
                    if(unit === 4) {
                        let val = (numValue*1) + 10000000;
                        setValues(val);
                        if(plusFunc) plusFunc(val);
                    }
                    if(unit === 5) {
                        let val = (numValue*1) + 10;
                        setValues(val);
                        if(plusFunc) plusFunc(val);
                    }
                    if(unit === 6) {
                        let val = (numValue*1) + 100;
                        setValues(val);
                        if(plusFunc) plusFunc(val);
                    }
                    if(unit === 7) {
                        let val = (numValue*1) + 1000;
                        setValues(val);
                        if(plusFunc) plusFunc(val);
                    }
                }}
            >
                <img src="./images/icons/add_line.svg" width='20' />
            </div>
        </div>
    )    
}